module.exports = __webpack_public_path__ + "assets/images/issue.svg?cf0436cf1275037c4b7cd4c484a450ef";


//////////////////
// WEBPACK FOOTER
// ./_source/images/notifications/issue.svg
// module id = 599
// module chunks = 0